/**
 * @flow
 * @author: Pavan
 */
import styled from 'react-emotion'
import Colors from '../../themes/Colors'
import { IcChevronRight } from '../../Icons'
import BaseButton from '../../commons/BaseButton'
import { mobile, desktop, tablet, maxDeviceWidth } from '../../utils/mixins'
import {
  Typo16White2RB,
  BaseRobotoRegular,
  Typo14BlackRR,
  Typo24BlackRM
} from '../../themes/Fonts'
import {
  Typo13WhiteDR,
  Typo14VeryLightBlueTwoDD
} from '../../themes/Fonts/Din2014'

import Input from './Input'

export const FormMobileMainContainer = styled('section')`
  user-select: none;
  display: flex;
  flex: 1;
  align-items: center;
  flex-direction: column;
`

export const ButtonIconContainer = styled('div')`
  margin-left: 10px;
`

export const SubmitBtnContainer = styled(BaseButton)`
  width: 280px;
  height: 40px;
  border-radius: 2px;
  background-color: ${Colors.pumpkinOrange};
  color: ${Colors.white};
`
export const ButtonWrapper = styled('div')`
  font-family: din-2014;
  font-size: 14px;
  font-weight: 500;
  color: ${Colors.white};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  pointer-events: none;
`

export const Divider = styled('span')`
  height: 15px;
`
export const InputContainer = styled(Input)`
  padding-right: ${props =>
    props.isBhowaniporePresentInQueryParams ? '10px' : '14px'};

  @media screen and (min-width: 1200px) and (max-width: 1352px) {
    margin-right: ${props =>
      props.isBhowaniporePresentInQueryParams ? '10px' : null};
  }

  @media screen and (min-width: 1353px) {
    margin-right: ${props =>
      props.isBhowaniporePresentInQueryParams ? '25px' : null};
  }
`

// Desktop Form Components

export const MainContainer = styled('div')`
  width: 100%;
  display: flex;
  border-left: 4px solid ${Colors.tangerineThree};
`

export const FormContainer = styled('div')`
  flex: 1;
  padding: 23px 30px;
  display: flex;
  justify-content: space-between;
  background-color: ${Colors.whiteTwo};
`

export const SubmitButton = styled('div')`
  cursor: pointer;
  padding-left: 23px;
  padding-right: 23px;
  background-color: ${Colors.pumpkinOrange};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`

export const ButtonLabel = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  margin-top: 7px;
`

export const LabelText = styled(Typo16White2RB)`
  margin-right: 10px;
  font-family: din-2014;
`

// Md Desktop styles

export const MainMdContainer = styled(MainContainer)``

export const FormMdContainer = styled(FormContainer)`
  position: relative;
`

export const SubmitMdButton = styled(SubmitButton)``
export const MdDesktop = styled('div')`
  position: relative;
  @media (min-width: 992px) and (max-width: 1352px) {
    display: block;
    padding-bottom: 20px;
  }
  @media (min-width: 1353px) {
    display: none;
  }
  @media (max-width: 991px) {
    display: none;
  }
`

export const Desktop = styled('div')`
  position: relative;
  @media (min-width: 768px) and (max-width: 1352px) {
    display: none;
  }
  @media (min-width: 1353px) {
    display: block;
  }
  @media (max-width: 767px) {
    display: none;
  }
`

export const Mobile = styled('div')`
  @media (min-width: 992px) {
    display: none;
  }
  @media (max-width: 991px) {
    display: block;
  }
`
export const Separator = styled('div')`
  @media (min-width: 992px) and (max-width: 1024px) {
    width: ${props =>
      props.isBhowaniporePresentInQueryParams ? '10px' : '15px'};
  }
  @media screen and (min-width: 1025px) {
    width: 15px;
  }
`

export const CloseIconWrapper = styled('div')`
  user-select: none;
  cursor: pointer;
  @media only screen and (max-width: 991px) {
    padding: 10px;
    padding-bottom: 0px;
    align-self: flex-end;
    margin-right: 7px;
    margin-bottom: 10px;
  }
`
const BaseRobotoRegularWithATag = BaseRobotoRegular.withComponent('a')

export const TandCApplyText = styled(BaseRobotoRegularWithATag)`
  opacity: 0.8;
  font-family: din-2014;
  font-size: 0.75em;
  font-style: italic;
  color: ${Colors.whiteTwo};
  text-align: center;
  position: relative;
  line-height: 1;
  padding-left: 0;
  padding-right: 0;
  cursor: pointer;
  :focus {
    color: ${Colors.whiteTwo};
    outline: none;
    text-decoration: none;
  }
  :hover {
    color: ${Colors.whiteTwo};
    outline: none;
    text-decoration: none;
  }
  :active {
    color: ${Colors.whiteTwo};
    outline: none;
    text-decoration: none;
  }
  ${mobile} {
    line-height: unset;
  }
  ${tablet} {
    line-height: unset;
  }
`
export const OfferText = styled(BaseRobotoRegularWithATag)`
  opacity: 0.8;
  font-size: 13px;
  font-style: italic;
  color: ${Colors.whiteTwo};
  text-align: center;
  position: relative;
  line-height: 1;
  padding-left: 0;
  padding-right: 0;
  cursor: pointer;
  :focus {
    color: ${Colors.whiteTwo};
    outline: none;
    text-decoration: none;
  }
  :hover {
    color: ${Colors.whiteTwo};
    outline: none;
    text-decoration: none;
  }
  :active {
    color: ${Colors.whiteTwo};
    outline: none;
    text-decoration: none;
  }
  ${mobile} {
    line-height: unset;
  }
  ${tablet} {
    line-height: unset;
  }
`
export const TandCTextInnerContainer = styled('div')`
  width: 194px;
  display: flex;
  justify-content: center;
  position: relative;
  top: 8px;
  left: 0;
  @media only screen and (max-width: 991px) {
    display: block;
    position: unset;
    width: unset;
    margin-top: 10px;
    margin-left: -15px;
  }
  @media (min-width: 992px) and (max-width: 1024px) {
    padding-bottom: 20px;
  }
`
export const TandCTextContainer = styled('div')`
  user-select: none;
  display: flex;
  justify-content: ${props => (props.showFaq ? 'space-between' : 'flex-end')};
  @media only screen and (max-width: 991px) {
    width: 280px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`
export const OffersContainer = styled('div')`
  display: none;
  @media only screen and (max-width: 991px) {
    display: flex;
    justify-content: center;
    padding-top: 10px;
  }
`
export const ButtonText = styled(Typo13WhiteDR)`
  width: 165px;
  text-align: center;
  margin: 0;
  padding-top: 7px;
  padding-bottom: 8px;
`

export const ButtonContainer = styled('div')`
  ${'' /* padding-top: 23px; */};
`
export const IconContainer = styled('div')`
  user-select: none;
  -moz-user-select: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  ${mobile} {
    top: 16px;
    right: 16px;
    width: 20px;
    height: 20px;
    z-index: 100;
  }
  ${desktop} {
    top: 30px;
    right: 30px;
    width: 20px;
    height: 20px;
  }
  ${tablet} {
    top: 30px;
    right: 30px;
    width: 20px;
    height: 20px;
    z-index: 100;
  }
`
export const TnCContainer = styled('div')`
  position: relative;
`
export const TnCMobileMainContainer = styled('section')`
  display: flex;
  flex: 1;
  align-items: center;
  flex-direction: column;
`
export const TnCCloseIconWrapper = styled('div')`
  user-select: none;
  cursor: pointer;
  @media only screen and (max-width: 991px) {
    padding: 10px;
    padding-bottom: 0px;
    align-self: flex-end;
    margin-right: 7px;
    margin-bottom: 10px;
  }
`
// TermsAndConditions Styled Components
export const TermsAndConditionsContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background-color: ${Colors.whiteTwo};
  overflow: hidden;
  ${desktop} {
    width: 830px;
    padding: 60px;
    height: calc(100vh - 150px);
  }
  ${mobile} {
    position: relative;
    padding: 40px 15px 40px 30px;
    width: 100%;
    height: calc(100vh - 150px);
  }
  ${tablet} {
    position: relative;
    padding: 50px;
    height: calc(100vh - 350px);
    width: 670px;
  }
`
export const TitleContainer = styled('div')`
  padding-right: 15px;
`
export const TnCTitle = styled(Typo24BlackRM)`
  font-family: din-2014;
  ${mobile} {
    font-size: 1.429em;
    line-height: 1.4;
    margin-bottom: 21.1px;
  }
  ${tablet} {
    font-size: 1.714em;
  }
  ${desktop} {
    font-size: 1.714em;
    line-height: 1;
  }
`

export const ContentContainer = styled('section')`
  user-select: text;
  display: flex;
  overflow-y: auto;
  ${desktop} {
    margin-top: 24px;
    height: calc(100vh - 310px);
  }
  ${tablet} {
    margin-top: 24px;
    height: calc(100vh - 500px);
  }
  ${mobile} {
    padding-right: 15px;
    margin-top: 21px;
    height: calc(100vh - 310px);
  }
`
export const TnCContent = styled(Typo14BlackRR)`
  font-size: 1em;
  font-family: din-2014;
  line-height: 1.7;
  ${mobile} {
    font-size: 0.929em;
  }
`
export const ArrowIcon = styled(IcChevronRight)`
  display: flex;
`

export const FaqButton = styled('button')`
  background: transparent;
  border: none;
  cursor: pointer;
  outline: none;
  padding: 0px;
  display: flex;
  ${maxDeviceWidth(991)} {
    display: none;
  }
`

export const FaqText = styled(Typo14VeryLightBlueTwoDD)`
  line-height: normal;
  letter-spacing: normal;
  border-bottom: solid 2px ${Colors.warmGreyThree};
  border-bottom-left-radius: 1px;
  color: ${Colors.blueyGreyThree};
  margin-top: 5px;
  ${mobile} {
    font-size: 10px;
    font-weight: normal;
    color: ${Colors.veryLightBlueTwo};
  }
`



// WEBPACK FOOTER //
// ./src/components/FormHomePage/styledComponents.js